import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogWrapperComponent } from '../../components/dialog-wrapper/dialog-wrapper.component';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
  selector: 'app-detailed-eye-analysis',
  standalone: true,
  imports: [CommonModule, DialogWrapperComponent, TranslatePipe],
  templateUrl: './detailed-eye-analysis.component.html',
  styleUrls: ['./detailed-eye-analysis.component.scss'],
})
export class DetailedEyeAnalysisComponent {
  eyeData: any;
  severity: string | null = null;

  constructor(
    private dialogRef: MatDialogRef<DetailedEyeAnalysisComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.eyeData = data.score.analysis[0].parameters;
    this.severity = data.score.analysis[0].severity;
  }
}
